<template>
  <div id="project-to-classroom">
    <div id="project-to-classroom" v-if = "classrooms.length > 0 || alwaysDisplay || teacher_classrooms.length >1">
          <h2> {{headerText}}</h2>
          <b-field label="">
             <b-select placeholder="Proyecto Personal" v-model="selectedClassroom" @input="$emit('input2', {'id':selectedClassroom,'isClassroomStudent': isClassroomStudent(selectedClassroom)})">
                <option :value="nullvalue"> Proyecto Personal </option>
                <optgroup label="Eres alumno de:" v-if = "classrooms.length > 0">
                <option
                     v-for="option in classrooms"
                     :value="option.id"
                     :key="option.id">
                     {{ option.name }}
                 </option>
                 </optgroup>
                   <optgroup label="No eres alumno de ninguna clase" v-else>
                  </optgroup>

                  <optgroup label="Eres profesor de estas clases:" v-if="isUserTeacher">
                    <option
                         v-for="option in teacher_classrooms"
                         :value="option.id"
                         :key="option.id">
                         {{ option.name }}
                     </option>
                  </optgroup>
             </b-select>
         </b-field>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ClassroomSelectList',
  data: () => ({
    selectedClassroom: null,
    nullvalue: null
  }),
  props: {
    headerText: {
      default: ''
    },
    alwaysDisplay: {
      default: false
    },
    user: {
      type: Object,
      required: true
    },
    currentClassroom: {
      default: ''
    }
  },
  computed: {
    classrooms () {
      if (this._.has(this.user, 'userInfo.classroom_set')) {
        // return this._.concat(this.user.userInfo.classroom_set, { id: null, name: 'Proyecto Personal' })
        return this.user.userInfo.classroom_set
      } else return []
    },
    teacher_classrooms () {
      if (this._.has(this.user, 'userInfo.classroom_set')) {
        return this.user.userInfo.owns_classrooms
      } else return []
    },
    isUserTeacher () {
      return this.$store.getters['user/isUserTeacher']
    }

  },
  methods: {
    isClassroomStudent (classid) {
      return this._.find(this.classrooms, function (o) { return o.id === classid })
    }
  },
  created () {
    if (this.currentClassroom !== '') {
      this.selectedClassroom = this.currentClassroom
    }
  }
}
</script>
<style lang="less" scoped>
#recent-projects, #project-to-classroom{
  margin-top: 1em;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/UI/ClassroomSelectList.vue